import React, {useEffect, useState, useContext} from 'react';
import ApplicationContext from './ApplicationContext';
import {getDataWithFetch} from "./Utils";
// import discoveryIcon from "../assets/images/discovery-icon.jpg";
// import discoveryIcon2 from "../assets/images/discovery-icon2.png";

const Tickers = () => {
	const data = useContext(ApplicationContext);
	// const [tickerStories, setTickerStories] = useState();
	const [tickerRobotNewsStories, setTickerRobotNewsStories] = useState();
	const [tickerEarningsStories, setTickerEarningsStories] = useState();
	const [tickerDividendStories, setTickerDividendStories] = useState();

    const [tickerSpaceStories, setTickerSpaceStories] = useState();
    const [tickerEuropeanSpaceStories, setTickerEuropeanSpaceStories] = useState();

    useEffect(() => {
        (async() => {
            if (data.BASE_URL) {
                let url, res;

                // url = data.BASE_URL + "index.php/news_data/get_ticker_stories";
                // // console.log('DEBUG:', url);
                // res = await getDataWithFetch(url);
                // // console.log('DEBUG:', res);
                // setTickerStories(res);

                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("robot news");
                // console.log('DEBUG:', url);
                res = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - Earnings Report News - ', res);
                setTickerRobotNewsStories(res);

                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("Earnings Report News");
                // console.log('DEBUG:', url);
                res = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - Earnings Report News - ', res);
                setTickerEarningsStories(res);

                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("Dividend News");
                // console.log('DEBUG:', url);
                res = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - Dividend News', res);
                setTickerDividendStories(res);

                // Add new ticker under new section for Space News, SpaceX News, Starlink News
                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("Space News");
                // console.log('DEBUG:', url);
                let res1 = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - Space News', res1);

                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("space x news");
                // console.log('DEBUG:', url);
                let res2 = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - space x news', res2);

                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("Starlink News");
                // console.log('DEBUG:', url);
                let res3 = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - Starlink News', res3);

				// Take the first 5 from each of these lists.
				let res4 = res1.slice(0,5).concat(res2.slice(0,5)).concat(res3.slice(0,5));
				// console.log('DEBUG:', res4);
				setTickerSpaceStories(res4);

                url = data.BASE_URL + "index.php/news_data/get_news_data/" + encodeURIComponent("European Space Agency News");
                // console.log('DEBUG:', url);
                let res5 = await getDataWithFetch(url);
                // console.log('DEBUG: get_news_data - Starlink News', res5);
				setTickerEuropeanSpaceStories(res5);
            }
        })();
    }, [data.BASE_URL]);

	// const observedH3a = useRef();
	// const [heightA, setHeightA] = useState();
	// const observedH3b = useRef();
	// const [heightB, setHeightB] = useState();

	// Need to make sure the element passed into "value" has an offsetHeight 
	// attribute.
	// const observeValue = (value, stateValue, setterFcn) => {
	// 	if (!value) {
	// 		return;
	// 	}
		
	// 	const resizeObserver = new ResizeObserver(() => {
	// 		if(value?.offsetHeight !== stateValue) {
	// 			setterFcn(value.offsetHeight);
	// 		}
	// 	});
		
	// 	resizeObserver.observe(value);
		
	// 	return function cleanup() {
	// 		resizeObserver.disconnect();
	// 	}	
	// };

	// So we can observe the height of two h3 tags independently and recyle the same function 
	// observeValue without having duplicate code.  We pass in the reference and state variables 
	// and setter respective functions.
	// useEffect(() => {
	// 	return observeValue(observedH3a.current, heightA, setHeightA);
	// }, [observedH3a.current]);

	// useEffect(() => {
	// 	return observeValue(observedH3b.current, heightA, setHeightB);
	// }, [observedH3b.current]);

	return (
		<>
			{/* <div className="discovery-row">
				<h3 className="discovery-text">Global Economic Analysis: Discovery Phase</h3>
			</div>

			<div className="discovery-row">
				<h3 className="discovery-text">Primary Node of Competition: Strategic Competitiveness Amongst International Exchanges (Bourses)</h3>
			</div>

			<div className="discovery-row">
				<h3 className="discovery-text">Secondary Node of Competition: (LEO) Strategic Competitivness in Space Station Design and Deployment.</h3>
			</div> */}

			{/* <div className="discovery-row">
				<div className="discovery-image-container">
					<img className="discovery-image" src={discoveryIcon} width="15" height="30" />
				</div>
				<img className="discovery-image" src={discoveryIcon2} width="150" height="30" />
			</div> */}

			{/* {tickerStories && <div className="carousel-container">
				<ul className="carousel-list" style={{animation: "scrollRight 40s linear infinite"}}>
					{tickerStories.slice(0,10).map((entry, index) => {
						let link = `https://news.google.com/${entry.link}`;
						return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font1" target="_blank" rel="noreferrer">{entry.title}</a></li>);
					})}
				</ul>
			</div>} */}

			{tickerRobotNewsStories && <div className="carousel-container">
				<ul className="carousel-list" style={{animation: "scrollLeft 50s linear infinite"}}>
					{tickerRobotNewsStories.slice(0,10).map((entry, index) => {
						let link = `https://news.google.com/${entry.link}`;
						return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font1" target="_blank" rel="noreferrer">{entry.title}</a></li>);
					})}
				</ul>
			</div>}

			{tickerEarningsStories && <div className="carousel-container">
				<ul className="carousel-list" style={{animation: "scrollRight 50s linear infinite"}}>
					{tickerEarningsStories.slice(0,10).map((entry, index) => {
						let link = `https://news.google.com/${entry.link}`;
						return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font1" target="_blank" rel="noreferrer">{entry.title}</a></li>);
					})}
				</ul>
			</div>}

			{tickerDividendStories && <div className="carousel-container">
				<ul className="carousel-list" style={{animation: "scrollLeft 50s linear infinite"}}>
					{tickerDividendStories.slice(0,10).map((entry, index) => {
						let link = `https://news.google.com/${entry.link}`;
						return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font1" target="_blank" rel="noreferrer">{entry.title}</a></li>);
					})}
				</ul>
			</div>}

            {/* <h3>Space News</h3> */}

            {tickerSpaceStories && <div className="carousel-container carousel-color2" >
				<ul className="carousel-list carousel-color2" style={{animation: "scrollRight 40s linear infinite"}}>
					{tickerSpaceStories.slice(0,10).map((entry, index) => {
						let link = `https://news.google.com/${entry.link}`;
						return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font  carousel-color2" target="_blank" rel="noreferrer">{entry.title}</a></li>);
					})}
				</ul>
			</div>}

            {tickerEuropeanSpaceStories && <div className="carousel-container carousel-color3" >
				<ul className="carousel-list carousel-color3" style={{animation: "scrollLeft 40s linear infinite"}}>
					{tickerEuropeanSpaceStories.slice(0,10).map((entry, index) => {
						let link = `https://news.google.com/${entry.link}`;
						return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font carousel-color3" target="_blank" rel="noreferrer">{entry.title}</a></li>);
					})}
				</ul>
			</div>}
        </>
	);
};

export default Tickers;
